import React, { createContext, useState } from 'react';

export enum ProfileViews {
  SELECT_PROFILE = 'select-profile',
  CREATE_PROFILE = 'create-profile',
  EDIT_PROFILE = 'edit-profile',
}

const ProfileNavigationContext = createContext(null);

export const ProfileNavigationProvider = ({ children }) => {
  const [profileView, setProfileView] = useState(ProfileViews.SELECT_PROFILE);
  return (
    <ProfileNavigationContext.Provider value={{ profileView, setProfileView }}>
      {children}
    </ProfileNavigationContext.Provider>
  );
};

export const useProfileNavigation = () =>
  React.useContext(ProfileNavigationContext);
